import { useTranslation } from 'react-i18next';
import { DATE_FORMAT_D_MMMM_YYYY } from '@/helpers/common';
import { prettyDate } from '@/helpers/utils';
import { useConfirmedAllocationStatus } from '@/hooks/shared/useConfirmedAllocationStatus';
import { useRoundStatus } from '@/hooks/shared/useRoundStatus';
import { useCalculateBonuses } from '@/containers/EveryFiveGroupA/useCalculateBonuses';
import { BrandSelectionInfo } from '../BrandSelectionInfo';
import { AllocationInfo } from '../AllocationInfo';
import { BonusInfo } from '../BonusInfo';
import s from './index.module.scss';

export const MyParticipation = () => {
  const { t } = useTranslation('investing');
  const { status } = useRoundStatus();
  const {
    allocatedGroupA,
    allocatedGroupB,
    totalAllocated,
    allocatedBonusAmount,
    isLoading,
  } = useConfirmedAllocationStatus();

  const { bonus } = useCalculateBonuses(allocatedGroupA, allocatedBonusAmount);

  return (
    <div className={s.wrapper}>
      <div className={s.title}>{t('my_participation.header')}</div>
      <div className={s.info}>
        <AllocationInfo
          allocatedGroupA={allocatedGroupA}
          allocatedGroupB={allocatedGroupB}
          totalAllocated={totalAllocated}
          bonusAmount={allocatedBonusAmount}
          isLoading={isLoading}
        />
        {!!bonus && <BonusInfo totalBonusAmount={bonus} />}
        <BrandSelectionInfo totalAllocated={totalAllocated} step="confirmed" />
      </div>
      <div className={s.note}>
        <div>
          {t('my_participation.modify_investment', {
            date: prettyDate(status.editable_until, DATE_FORMAT_D_MMMM_YYYY),
          })}
        </div>
        <div>{t('my_participation.round_over')}</div>
      </div>
    </div>
  );
};
